import { IGetRedirectsDTO, RedirectType } from '@/models/redirects.model';
import { TGetRedirectsQuery } from '../helpers/types';

class GetRedirectsDTO implements IGetRedirectsDTO {
  type?: RedirectType;
  source?: string;
  target?: string;
  page?: number;

  constructor({
    target,
    source,
    type,
    page,
  }: TGetRedirectsQuery & {
    page: number;
  }) {
    this.type = type;
    this.source = source;
    this.target = target;
    this.page = page;
  }
}

export default GetRedirectsDTO;
